const initPostList = () => {
  if(document.querySelector('.sand-list-posts')){
    let page = 1;
    const loadPosts = (data) => {
      fetch(ajax_front.ajax_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(data).toString(),
      }).then(response => response.json()).then((response) => {
        console.log(response);
        const element = document.querySelector('#sand-posts-list-container');
        element.innerHTML = response.html;
        if (response.max_num_pages > 1) {
          document.querySelector('#post-load-more--wrapper').style.display = 'block';
        } else {
          document.querySelector('#post-load-more--wrapper').style.display = 'none';
        }
      }).catch((error) => {
        console.error('Error:', error);
      });

    };
    const intFilterBtn = () => {
      document.querySelectorAll('.sand-post-filter-btn').forEach(function(element) {
        element.addEventListener('click', function (e){
          document.querySelectorAll('.sand-post-filter-btn.active').forEach(function (ele){
             ele.classList.remove('active');
          });
          e.target.classList.add('active');
          page = 1;
          let data = {
            'action': 'load_posts',
            'post_cat': '' // die ausgewählten Kategorien
          };
          data['post_cat'] = e.target.dataset.catsid;
          loadPosts(data);
        })
      });
    }
    const loadMorePosts = () => {
      page++; // Inkrementiert die Seite jedes Mal, wenn der "Mehr laden"-Button geklickt wird
      let data = {
        'action': 'loadmore_posts',
        'post_cat': '',
        'page': page
      };

      const activeFilter = document.querySelector('.sand-post-filter-btn.active');
      data['post_cat'] = activeFilter.dataset.catsid;
      fetch(ajax_front.ajax_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(data).toString(),
      }).then(response => response.json()).then((response) => {
        const element = document.querySelector('#sand-posts-list-container');
        element.innerHTML +=response.html;
        if (response.max_num_pages > page) {
          document.querySelector('#post-load-more--wrapper').style.display = 'inline-block';
        } else {
          document.querySelector('#post-load-more--wrapper').style.display = 'none';
        }
      }).catch((error) => {
        console.error('Error:', error);
      });

    }
    const intLoadMore = () =>{
      let loadMoreBtn = document.getElementById('post-load-more');
      loadMoreBtn.addEventListener('click', loadMorePosts);
    }
    const showPostList = () =>{
      const postType = document.querySelector(".sand-post-filter-btn.active").dataset.catsid;
      let data = {
        'action': 'load_posts',
        'post_cat': postType
      };
      loadPosts(data);
    }

    showPostList();
    intLoadMore();
    intFilterBtn();
  }
}
export default initPostList;
